import { PromoCodeData } from "../global"

export function isForSignedInUser(listOfPromocode: PromoCodeData[], validPromoCode: string): boolean {
    return listOfPromocode?.some((promoCode: any) => promoCode?.promoCode === validPromoCode && promoCode?.isForSignedInUser)
}